import { createContext } from "react";

import useMenu from "components/Frame/useMenu";

export const GlobalContext = createContext();

const Global = ({ children }) => {
  const managementMenuController = useMenu();
  const global = {
    managementMenuController
  };
  return <GlobalContext.Provider value={global}>{children}</GlobalContext.Provider>;
};

export default Global;